import { useEffect } from "react";

const HIDE_CHAT_STYLE_ID = "chat-hide-style";
export const hideSupportChat = () => {
  const hideStyle = document.getElementById(HIDE_CHAT_STYLE_ID);
  if (!hideStyle) {
    const style = document.createElement("style");
    style.id = HIDE_CHAT_STYLE_ID;
    style.innerHTML = `
      #amazon-connect-chat-widget {
        display: none;
      }
    `;
    document.head.appendChild(style);
  }
};

export const showSupportChat = () => {
  const hideStyle = document.getElementById(HIDE_CHAT_STYLE_ID);
  if (hideStyle) {
    document.head.removeChild(hideStyle);
  }
};

// The Amazon Connect widget renders its own launcher button into the document.
// Clicking it is the supported way to open the chat panel — configuring
// `customLaunchBehavior.programmaticLaunch` instead would stop the widget from
// rendering the launcher at all. When the chat is already open the button is
// swapped for a close button, so a missing element means there is nothing to do.
const OPEN_CHAT_BUTTON_ID = "amazon-connect-open-widget-button";

export const openSupportChat = () => {
  document.getElementById(OPEN_CHAT_BUTTON_ID)?.click();
};

export function useHideSupportChat() {
  useEffect(() => {
    hideSupportChat();

    return () => {
      showSupportChat();
    };
  }, []);
}
